import { render, staticRenderFns } from "./userUpdate.vue?vue&type=template&id=594bd474&scoped=true&"
import script from "./userUpdate.vue?vue&type=script&lang=js&"
export * from "./userUpdate.vue?vue&type=script&lang=js&"
import style0 from "./userUpdate.vue?vue&type=style&index=0&id=594bd474&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594bd474",
  null
  
)

export default component.exports